import { ItpIssueStatus } from 'data/generated/graphql';

export const getItpCurrentStatus = (status?: ItpIssueStatus) => {
  if (status && [ItpIssueStatus.Changed, ItpIssueStatus.Published].includes(status)) return ItpIssueStatus.Published;

  return status ?? ItpIssueStatus.Draft;
};
